import { render, staticRenderFns } from "./DesktopApp.vue?vue&type=template&id=1952a796"
import script from "./DesktopApp.vue?vue&type=script&lang=ts"
export * from "./DesktopApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1952a796')) {
      api.createRecord('1952a796', component.options)
    } else {
      api.reload('1952a796', component.options)
    }
    module.hot.accept("./DesktopApp.vue?vue&type=template&id=1952a796", function () {
      api.rerender('1952a796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/plugins/DesktopApp.vue"
export default component.exports